<div class="configuration-planning-staff-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="staff()"></grid-content>

</div>